import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export const offer = {
  namespaced: true,
  state: {
    offer: {},
  },
  mutations,
  actions,
  getters,
}
